import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { MOBILE_APP as PRE } from 'main/util/i18n/namespaces'
import { ButtonContainer, ButtonsContainer, Container } from './Footer.styles'

import { Title } from 'main/ui/typography'
import AppStoreButton from './AppStoreButton'
import GooglePlayButton from './GooglePlayButton'

export default function Footer() {
  const { t } = useTranslation(NAMESPACE)
  return (
    <Container>
      <Title kind="large" color="white">
        {t(`${PRE}-DOWNLOAD-THE-APP-TODAY`)}
      </Title>
      <ButtonsContainer>
        <ButtonContainer>
          <AppStoreButton />
        </ButtonContainer>
        <ButtonContainer>
          <GooglePlayButton />
        </ButtonContainer>
      </ButtonsContainer>
    </Container>
  )
}
